import { render, staticRenderFns } from "./Income.vue?vue&type=template&id=bc4e9b52&scoped=true&"
import script from "./Income.vue?vue&type=script&lang=js&"
export * from "./Income.vue?vue&type=script&lang=js&"
import style0 from "./Income.vue?vue&type=style&index=0&id=bc4e9b52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4e9b52",
  null
  
)

export default component.exports